<div class="dashboard-tile dialog">
  <app-grid-spinner #spinner></app-grid-spinner>
  <div *ngIf="title" class="tile-header dialog-header">
    <div class="tile-header-title">
      <ng-container *ngIf="subTitle">
        <font class="text-primary">{{title}}</font> - {{subTitle}}
      </ng-container>
      <ng-container *ngIf="!subTitle">
      {{title}}
      </ng-container>
    </div>
    <div class="tile-header-action">
      <ng-content select="div.custom-header-action"></ng-content>
      <mat-icon *ngIf="showCloseButton" class="close-icon" color="primary" (click)="onCloseIcon()" aria-label="close">clear</mat-icon>
    </div>
  </div>
  <div mat-dialog-content class="tile-content dialog-content">
    <img *ngIf="showLogo" mat-card-image class="tile-logo dialog-logo" src="{{themeManager.getStackedLogo()}}" >
    <span class="dialog-content-wrapper">
      <ng-content></ng-content>
    </span>
    <div *ngIf="buttons.length > 0" mat-dialog-actions class="tile-footer dialog-footer">
      <ng-content select="[mat-button], [mat-raised-button], [mat-icon-button]"></ng-content>
    </div>
  </div>
</div>